const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/actions/intlActions.ts';
import { SupportedLocale } from '../defs/generalDefs';

export const atSetI18nLocalePending = 'COMMON_SET_I18N_LOCALE_PENDING';
export const atSetI18nLocaleSuccess = 'COMMON_SET_I18N_LOCALE_SUCCESS';

/**
 * Call this function to switch the language. The intlSaga listens to this action and will load the intl dictionary.
 */
export function actionSetI18nLocale(locale: SupportedLocale) {
    return {
        type: atSetI18nLocalePending,
        meta: { locale },
    };
}

export type SetI18nLocalePendingAction = ReturnType<typeof actionSetI18nLocale>;

/**
 * Called by intlSaga when the intl dictionary was successfully loaded from assets.
 * @param locale The new locale
 * @param dictionary The loaded translations, or null if locale is the default locale
 */
export function actionSetI18nLocaleSuccess(locale: SupportedLocale, dictionary: Record<string, string> | null) {
    return {
        type: atSetI18nLocaleSuccess,
        dictionary,
        meta: { locale },
    };
}

export type SetI18nLocaleSuccessAction = ReturnType<typeof actionSetI18nLocaleSuccess>;
